// utils/dateUtils.js

export const getFormattedDateTimeEST = () => {
  try {
    const currentDate = new Date()

    if (isNaN(currentDate.getTime())) {
      throw new Error('Invalid Date')
    }

    // Convert to EST
    const options = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false // Ensures 24-hour format
    }

    const dateTimeString = new Intl.DateTimeFormat('en-US', options).format(currentDate)

    if (!dateTimeString || !dateTimeString.includes(',')) {
      throw new Error('Failed to format date/time')
    }

    // Extract and format date and time
    const [datePart, timePart] = dateTimeString.split(',')
    const formattedDate = datePart ? datePart.trim().replace(/\//g, '-') : '00-00-0000'
    const formattedTime = timePart ? timePart.trim().replace(/:/g, '') : '000000'

    return { formattedDate, formattedTime }
  } catch (error) {
    console.error('Error formatting date/time:', error)
    return { formattedDate: '00-00-0000', formattedTime: '000000' } // Fallback values
  }
}
